import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import {  useTranslation } from 'react-i18next';

export default function VendorBidRequest() {
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const translate = t;
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef} tabIndex={0}>
          <div id="content" className="dashboard-wrap campaign-section">
            <nav className="breadcrumb" aria-label="breadcrumb">
              <ol>
                <li className="breadcrumb-item active" aria-current="page">
                  {translate("home")}
                </li>
              </ol>
            </nav>
            <div className="vender-bids-section flex">
              <div className="vender-bids-left vender-bids listing-wrap-data">
                <ul className="listing-tab-link flex">
                  <li><button className="active">Bids Request</button></li>
                  <li><button>Bids To Complete</button></li>
                  <li><button>Bids Submitted</button></li>
                  <li><button>Bids Won</button></li>
                 </ul>
                <div className="white-bg mh-550">
                  <p className="para">All bid requests awaiting your acceptance or rejection</p>
                  <div className="no-data-display align-center hide">
                    <i className="nodata-icon"></i>
                    <p>Data not availaible</p>
                  </div> 
                     <div className="table-responsive global-table">
                        <table className="sortable">
                          <thead>
                            <th>Project Name</th>
                            <th>Due Date</th>
                            <th>Customer</th>
                          </thead>
                          <tbody>
                            <tr>
                              <td><a href="#">Downtown New</a></td>
                              <td>10/19/22  5:00:00 PM PDT</td>
                              <td>Sunil Tripathy</td>
                            </tr>
                            <tr>
                              <td><a href="#">Downtown New</a></td>
                              <td>10/19/22  5:00:00 PM PDT</td>
                              <td>Sunil Tripathy</td>
                            </tr>
                            <tr>
                              <td><a href="#">Downtown New</a></td>
                              <td>10/19/22  5:00:00 PM PDT</td>
                              <td>Sunil Tripathy</td>
                            </tr>
                            <tr>
                              <td><a href="#">State L Bid</a></td>
                              <td>10/19/22  5:00:00 PM PDT</td>
                              <td>Sunil Tripathy</td>
                            </tr>
                            <tr>
                              <td><a href="#">Downtown New</a></td>
                              <td>10/19/22  5:00:00 PM PDT</td>
                              <td>Sunil Tripathy</td>
                            </tr>
                            <tr>
                              <td><a href="#">Downtown New</a></td>
                              <td>10/19/22  5:00:00 PM PDT</td>
                              <td>Sunil Tripathy</td>
                            </tr>
                            <tr>
                              <td><a href="#">Local Bid</a></td>
                              <td>10/19/22  5:00:00 PM PDT</td>
                              <td>Sunil Tripathy</td>
                            </tr>
                            <tr>
                              <td><a href="#">State L Bid</a></td>
                              <td>10/19/22  5:00:00 PM PDT</td>
                              <td>Sunil Tripathy</td>
                            </tr>
                          </tbody>
                        </table>
                        </div>
                </div>
              </div>
              <div className="vender-bids-right vender-bids">
                <h5>209 Tasks Assigned to Me</h5>
                <div className="white-bg mh-550">
                  <div className="task-assign-list">
                    <h6>OPAL-Marketing automatically created task</h6>
                    <a href="#">Review  Translation (Romania)</a>
                    <div className="flex justify-center">
                      <span>Created -- <small>02:59 PM</small></span>
                      <div className="assign-due flex-center" aria-label="due today">
                        <svg className="watch-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                          <path d="M8 15.5C11.866 15.5 15 12.366 15 8.5C15 4.63401 11.866 1.5 8 1.5C4.13401 1.5 1 4.63401 1 8.5C1 12.366 4.13401 15.5 8 15.5Z" stroke="#FF313D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                          <path d="M8 5.17517V9.37517L10.8 10.7752" stroke="#FF313D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>28-11-2022
                      </div>
                    </div>
                  </div>
                  <div className="task-assign-list">
                    <h6>OPAL-Marketing automatically created task</h6>
                    <a href="#">Review  Translation (Romania)</a>
                    <div className="flex justify-center">
                      <span>Created -- <small>02:59 PM</small></span>
                      <div className="assign-due flex-center" aria-label="due today">
                        <svg className="watch-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                          <path d="M8 15.5C11.866 15.5 15 12.366 15 8.5C15 4.63401 11.866 1.5 8 1.5C4.13401 1.5 1 4.63401 1 8.5C1 12.366 4.13401 15.5 8 15.5Z" stroke="#FF313D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                          <path d="M8 5.17517V9.37517L10.8 10.7752" stroke="#FF313D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>28-11-2022
                      </div>
                    </div>
                  </div>
                  <div className="task-assign-list">
                    <h6>OPAL-Marketing automatically created task</h6>
                    <a href="#">Review  Translation (Romania)</a>
                    <div className="flex justify-center">
                      <span>Created -- <small>02:59 PM</small></span>
                      <div className="assign-due flex-center" aria-label="due today">
                        <svg className="watch-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                          <path d="M8 15.5C11.866 15.5 15 12.366 15 8.5C15 4.63401 11.866 1.5 8 1.5C4.13401 1.5 1 4.63401 1 8.5C1 12.366 4.13401 15.5 8 15.5Z" stroke="#FF313D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                          <path d="M8 5.17517V9.37517L10.8 10.7752" stroke="#FF313D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>28-11-2022
                      </div>
                    </div>
                  </div>
                  <div className="task-assign-list">
                    <h6>OPAL-Marketing automatically created task</h6>
                    <a href="#">Review  Translation (Romania)</a>
                    <div className="flex justify-center">
                      <span>Created -- <small>02:59 PM</small></span>
                      <div className="assign-due flex-center" aria-label="due today">
                        <svg className="watch-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                          <path d="M8 15.5C11.866 15.5 15 12.366 15 8.5C15 4.63401 11.866 1.5 8 1.5C4.13401 1.5 1 4.63401 1 8.5C1 12.366 4.13401 15.5 8 15.5Z" stroke="#FF313D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                          <path d="M8 5.17517V9.37517L10.8 10.7752" stroke="#FF313D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>28-11-2022
                      </div>
                    </div>
                  </div>
                 </div>
              </div>
            </div>
          </div>
        </section>
      </div>
     
    </div>
  )
}
